<div style="display: flex; flex-direction: column; height: 100%">
  <!-- <h1 mat-dialog-title>裁剪图片</h1> -->
  <div mat-dialog-content style="flex: 1; max-height: 100vh; padding: 0px">
    <img id="cropper" />
  </div>
  <div mat-dialog-actions style="justify-content: end; width: 100%">
    <button mat-button mat-dialog-close [disabled]="loading">取消</button>
    <button mat-button color="primary" (click)="crop()" [disabled]="loading">
      确认
    </button>
  </div>
</div>
